import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes"
import { apiError, loginSuccess } from "./actions"
import cookieHelper from "helpers/cookie_helper"
import { LOGIN_URL } from "helpers/url_helper"
import { post, get } from "helpers/api_helper"

const authCall = async data => await post(LOGIN_URL, data);

function* loginUser({ payload: { user, history } }) {
  try {
    const mockResponse = {
      status: 200,
      message: "Login successful",
      data: {
        accessToken: "static-superadmin-token-12345",
        session_id: "static-superadmin-session-12345",
        email: user.email || "sairam@gmail.com",
        name: "Super Admin",
        role: "superadmin"
      },
      email: user.email || "sairam@gmail.com",
      username: "Super Admin",
      displayName: "Super Admin",
      uid: 1,
      role: "superadmin",
      accessToken: "static-superadmin-token-12345",
      session_id: "static-superadmin-session-12345"
    }

    const resObj = mockResponse.data

    Object.keys(resObj).forEach(v => {
      localStorage.setItem(v, resObj[v])
    })

    localStorage.setItem("authUser", JSON.stringify(mockResponse))
    cookieHelper.setCookie(
      "authUser",
      JSON.stringify({
        email: user.email || "sairam@gmail.com",
        password: user.password || "sai@777",
        is_login: user.is_login,
        phone: user.phone,
        country_code: user.country_code,
      }),
      7,
      "/",
      ""
    )
    yield put(loginSuccess(mockResponse))

    if (
      cookieHelper.getCookie("authUser") ||
      localStorage.getItem("authUser")
    ) {
      window.location.href = "/dashboard"
    } else {
      history.push("/logout")
    }
  } catch (error) {
    yield put(apiError(error))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser")
    cookieHelper.deleteCookie("authUser")
    history.push("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
